(function () {
    'use strict';

    var module = angular.module('uwAgenda.downloads');
    module.factory('DownloadService', ['$http', 'HelperService', 'DateService', 'ExportFormat', 'SharedAgendaService', DownloadServiceFn]);

    /* main service for download APIs  */
    function DownloadServiceFn($http, HelperService, DateService, ExportFormat, SharedAgendaService) {
        var baseUrl = '/api/downloads/';

        var service = {
            exportAgenda: exportAgenda,
            exportAgendaPeriod: exportAgendaPeriod,
            exportAppointments: exportAppointments,
            exportAppointmentList: exportAppointmentList,
            exportTasks: exportTasks,
            exportFilteredTasks: exportFilteredTasks,
            exportCallsAndMessages: exportCallsAndMessages,
            exportContacts: exportContacts,
            exportFilteredContacts: exportFilteredContacts,
            exportEmails: exportEmails,
            exportFilteredEmails: exportFilteredEmails,
            exportChart: exportChart,
            exportAppointment: exportAppointment,
            openReport: openReport
        };

        return service;

        /* export agenda */
        function exportAgenda(exportFormat, userId, dateFrom, dateTo) {
            return $http({
                url: baseUrl + 'agenda/' + exportFormat + '/' + userId,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    dateFrom: HelperService.backendDate(dateFrom),
                    dateTo: HelperService.backendDate(dateTo)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export agenda for period (day/week) */
        function exportAgendaPeriod(exportFormat, userId, forDay, date) {
            return $http({
                url: baseUrl + 'agendaperiod/' + exportFormat + '/' + userId + '/' + forDay,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    date: HelperService.backendDate(date)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export appointments */
        function exportAppointments(exportFormat, userId, dateFrom, dateTo) {
            return $http({
                url: baseUrl + 'appointments/' + exportFormat + '/' + userId,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    dateFrom: HelperService.backendDate(dateFrom),
                    dateTo: HelperService.backendDate(dateTo)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export appointment list */
        function exportAppointmentList(exportFormat, userId, startDate, endDate, appointmentStates, getDeleted, getUnconfirmed, getUrgent, number) {
            return $http({
                url: baseUrl + 'appointmentlist/' + exportFormat + '/' + userId + '/' + (getDeleted ? getDeleted : false) + '/' + (getUnconfirmed ? getUnconfirmed : false) + '/' + (getUrgent ? getUrgent : false),
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    startDate: (startDate ? HelperService.backendDate(startDate) : null),
                    endDate: (endDate ? HelperService.backendDate(endDate) : null),
                    appointmentStates: (appointmentStates ? appointmentStates : null),
                    number: (number ? number : null)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export tasks */
        function exportTasks(exportFormat, userId, dateFrom, dateTo) {
            return $http({
                url: baseUrl + 'tasks/' + exportFormat + '/' + userId,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    dateFrom: HelperService.backendDate(dateFrom),
                    dateTo: HelperService.backendDate(dateTo)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export tasks for given ids */
        function exportFilteredTasks(exportFormat, userId, taskIds) {
            return $http({
                url: baseUrl + 'filteredtasks/' + exportFormat + '/' + userId,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    ids: (taskIds ? taskIds : null)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export calls & messages */
        function exportCallsAndMessages(exportFormat, userId, dateFrom, dateTo) {
            return $http({
                url: baseUrl + 'callsmessages/' + exportFormat + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/' + userId,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    dateFrom: HelperService.backendDate(dateFrom),
                    dateTo: HelperService.backendDate(dateTo)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export contacts (only csv) */
        function exportContacts(userId) {
            return $http({
                url: baseUrl + 'users/' + userId,
                method: 'GET',
                responseType: "arraybuffer"
            }).then(function (response) {
                return response.data;
            });
        }

        /* export contacts for given ids (only csv) */
        function exportFilteredContacts(userId, active, blocked, deleted, filter) {
            return $http({
                url: baseUrl + 'filteredusers/' + userId + "/active/" + active + "/blocked/" + blocked + "/deleted/" + deleted,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    searchFilter: filter.searchFilter,
                    roles: filter.roles,
                    sharedAgendaOwnerIds: filter.sharedAgendaOwnerIds
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export emails (only csv) */
        function exportEmails(userId) {
            return $http({
                url: baseUrl + 'emails/' + userId,
                method: 'GET',
                responseType: "arraybuffer"
            }).then(function (response) {
                return response.data;
            });
        }

        /* export emails for given ids (only csv) */
        function exportFilteredEmails(userId, emailIds) {
            return $http({
                url: baseUrl + 'filteredemails/' + userId,
                method: 'GET',
                responseType: "arraybuffer",
                params: {
                    ids: (emailIds ? emailIds : null)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* export single appointment (label or prescription) */
        function exportAppointment(appointmentId, userId, agendaId, printPrescription, documentType) {
            return $http({
                url: baseUrl + 'appointment/' + appointmentId + '/' + userId + '/agendas/' + agendaId + '/' + (printPrescription ? printPrescription : false) + '/' + documentType,
                method: 'GET',
                responseType: "arraybuffer"
            }).then(function (response) {
                return response.data;
            });
        }

        /* export chart-image (only pdf) */
        function exportChart(userId, chartData) {
            //todo: not working yet!
        }

        /* open/download the report */
        function openReport(exportFormat, responseData, filenamePrefix) {
            var a = document.createElement('a');

            var file = null;
            var filenameSuffix = null;

            if (exportFormat === ExportFormat.CSV.value) {
                filenameSuffix = "csv";
                // add utf8-BOM for correct encoding when opening csv in Excel
                file = new Blob(["\ufeff", responseData], { type: "application/csv" });
            }else if (exportFormat === ExportFormat.WORD.value) {
                filenameSuffix = "docx";
                file = new Blob([responseData], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
            }
            else {
                filenameSuffix = "pdf";
                file = new Blob([responseData], { type: "application/pdf" });
            }

            var fileUrl = URL.createObjectURL(file);

            // IE 11
            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                window.navigator.msSaveOrOpenBlob(file, filenamePrefix + "." + filenameSuffix);
            } // if
            else {
                a.href = fileUrl;
                a.download = filenamePrefix + "." + filenameSuffix;
                a.hidden = 'hidden';
                a.click();
                a.remove();
            }
        }
    }
})();